<template>
    <section class="sidebarFilter">
        <p class="sidebarFilter__desc">
            {{ trans('FORM_FILTER_PUBLICATIONDATE_TEXT') }}
        </p>
        <label
            v-for="(interval, index) in intervalData"
            :key="index"
            class="sidebarFilter__wrapperCheckBox sidebarFilter__wrapperPublicationDate">
            <span class="sidebarFilter__publicationDateCheckBox sidebarFilter__checkBox">
                <input
                    ref="checkbox"
                    v-model="selectedInterval"
                    :data-gtm="`sidebarFilter__publicationDate--option${ index }`"
                    type="checkbox"
                    class="customCheckboxInput"
                    :value="interval.value"
                    :checked="interval.isActive"
                    :multiple="true"
                    :name="interval.value"
                    @change="setIntervalData(interval.value)" />
                <span class="customCheckbox"></span>
                {{ interval.label }}
            </span>
        </label>
    </section>
</template>

<script>
    import { useGetters } from 'composables/useVuex';
    import Translator from 'tools/trans';
    export default {
        name: 'PublicationDateFilter',
        data() {
            return {
                selectedInterval: this.interval,
                publicationDateCheckbox: true,
                active: true,
            };
        },
        watch: {
            selectedInterval: {
                handler(val) {
                    if (this.selectedInterval.length === this.intervalData.length || this.selectedInterval.length === 0) {
                        // If "all" checkboxes are selected we only want to emit '0'
                        this.$emit('selected-interval', [this.intervalData[0].value]);
                        this.$parent.$emit('selected-interval', [this.intervalData[0].value]);
                    } else {
                        this.$emit('selected-interval', val);
                        this.$parent.$emit('selected-interval', val);
                    }
                },
                deep: true,
            },
        },
        methods: {
            trans: Translator.trans,
            setIntervalData(interval) {
                if (interval === this.intervalData[0].value) {
                    // If all values (except 'all') are selected we want to select 'all' as well. intervalData.length - 1 = 8 then we have all values checked except 'all'
                    if (this.selectedInterval.length === (this.intervalData.length - 1)) {
                        if (this.selectedInterval.includes(this.intervalData[0].value)) {
                            this.addAllIntervalValues();
                        } else {
                            this.selectedInterval = [];
                        }
                    } else {
                        this.addAllIntervalValues();
                    }
                } else {
                    if (this.selectedInterval.includes(this.intervalData[0].value)) {
                        this.removeFromArray(this.intervalData[0].value);
                    } else if (!this.selectedInterval.includes(this.intervalData[0].value) && this.selectedInterval.length === (this.intervalData.length - 1)) {
                        this.addAllIntervalValues();
                    }
                }
            },
            removeFromArray(num) {
                const positionIsInArray = this.selectedInterval.indexOf(num);
                this.selectedInterval.splice(positionIsInArray, 1);
            },
            addAllIntervalValues() {
                this.selectedInterval = [];
                this.intervalData.forEach(el => {
                    this.selectedInterval.push(el.value);
                });
            },
        },
        mounted() {
            if (Array.isArray(this.interval) && this.interval.includes(this.intervalData[0].value)) {
                this.addAllIntervalValues();
            }
        },
        setup() {
            const getters = {
                ...useGetters('search', [
                    'intervalData',
                    'query',
                    'resultCount',
                    'resultArray',
                    'masterTags',
                    'promotedArray',
                    'repoArray',
                    'entity',
                    'entityName',
                    'getTitle',
                    'getContent',
                    'currentPage',
                    'totalFound',
                    'totalPages',
                    'loading',
                    'activeTab',
                    'topic',
                    'topics',
                    'countries',
                    'path',
                    'tags',
                    'getShowSidebar',
                    'interval',
                ]),
            };

            return {
                ...getters,
            };
        },
    };
</script>
